/*!*
 * @author yueheqin
 * @date 2019/6/17
 * @project zujuanzaixian
 * @desc
 */
// 会员中心-个人用户
import request from '../utils/request'
import { API_URL } from '../config'

const vip = {
  personUser: API_URL + 'v1/home/person', // 会员中心-个人用户
  groupUser: API_URL + 'v1/home/group', // 会员中心-集体用户
  vipInfo: API_URL + 'v1/user/vip-info', // 会员中心-集体用户
  buyVip: API_URL + 'v1/user/buy-vip', // 购买VIP
  getVip: API_URL + 'v1/user/change-vip' // 领取VIP
}

export const personUserApi = (config) => request.get(vip.personUser, config)

// 会员中心-集体用户
export const groupUserApi = (config) => request.get(vip.groupUser, config)

// 会员中心-集体用户
export const vipInfoApi = (params, config) => request.get(vip.vipInfo, {params, ...config})

// 会员中心-确认付款
export const buyVipApi = (params, config) => request.get(vip.buyVip, {params, ...config})

// 免费领取vip
export const getVipApi = (params, config) => request.post(vip.getVip, {params, ...config})
